<template>
  <div>
    <div v-if="docView" class="title">
      <span style="font-size: 17px;">
        {{ docView.title || docView.filename || 'no title' }}</span
      >
      <span v-if="docView.author" style="font-size: 14px; font-style: italic;">
        by {{ docView.author }}</span
      >
      <span v-if="docView.authors" style="font-size: 12px;">
        by {{ docView.authors }}</span
      >
      <br />
      <span v-if="docView.filename" class="meta">
        <span style="font-weight: bold;">filename</span>:
        {{ docView.filename.split('/').slice(-1)[0] }}
      </span>
      <span v-if="docView.filetype" class="meta">
        <span style="font-weight:bold;">filetype</span>: {{ docView.filetype }}
      </span>
      <br />
      <span v-if="docView.src" class="meta">
        <span style="font-weight:bold;">src</span>: {{ docView.src }}
      </span>

      <button
        v-if="!loading"
        @click="anaOn = !anaOn"
        style="margin-left: 20px;"
      >
        <md-icon style="color: orange">library_books</md-icon>
      </button>
    </div>
    <div v-if="loading">
      <span> {{ col + ' / ' + _key }}</span>
      <span class="loading dots2" />
      <span v-show="viewProg">{{ viewProg + '%' }}</span>
    </div>
    <div v-else-if="docView._id" id="content">
      <div id="text-content">
        <div v-if="docView.filetype === '.pdf' && docView.bytes">
          <PDF :loading="loading" :docView="docView" />
        </div>
        <div
          v-else-if="!loading && docView.html"
          v-html="docView.html"
          class="doc"
        />
        <pre v-else-if="!loading && docView.text" class="plain-text">
      {{ docView.text }}</pre
        >
      </div>
      <Analytics
        v-if="!loading && docView.text && anaOn"
        :text="docView.text"
        :query="query"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PDF from '@/components/view/PDF'
import Analytics from '@/components/view/Analytics'

export default {
  props: ['col', '_key'],

  components: {
    PDF,
    Analytics,
  },

  computed: {
    ...mapState({
      docView: state => state.search.docView,
      viewProg: state => state.search.viewProg,
    }),

    _id() {
      return this.col + '/' + this._key
    },

    query() {
      const q = this.$route.query
      if (!q) return []
      return JSON.parse(q.query)
    },
  },

  data() {
    return {
      loading: false,
      anaOn: false,
    }
  },

  watch: {
    _id: {
      handler: async function(val) {
        this.loading = true
        await this.$store
          .dispatch('search/view', val)
          .catch(e => (this.loading = false))
        this.loading = false
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
#content {
  display: flex;
  max-height: 90vh;
  max-width: 100%;
  justify-content: flex-start;
  border: solid 1px blue;
}

#text-content {
  border: solid 1px red;
  overflow-y: scroll;
}

.title {
  width: 100%;
  margin: 4px;
  padding: 4px;
  font-weight: bold;
}
.meta {
  font-size: 11px;
  font-weight: normal;
}

.plain-text {
  margin: 4px;
  padding: 4px;
  background-color: #fefeff;
  font-family: Monda;
}
.doc {
  margin: 4px;
  padding: 4px;
  background-color: #fefeff;
  font-family: Monda;
}
.pdf {
  margin: 4px;
  padding: 4px;
}
</style>
